import { useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';
import { PageTransition, StaggerContainer, StaggerItem } from '../components/PageTransition';
import { BackButton } from '../components/BackButton';

// User-provided images
const JACKET_IMAGE = 'https://customer-assets.emergentagent.com/job_luxury-academy-2/artifacts/e9w8zobb_JACKET.webp';
const SUNGLASSES_IMAGE = 'https://customer-assets.emergentagent.com/job_luxury-academy-2/artifacts/3t8lkhyl_SUNGLASS.webp';
const SHOES_IMAGE = 'https://customer-assets.emergentagent.com/job_luxury-academy-2/artifacts/gp8m9ccb_SHOES.webp';

const categories = [
  { 
    id: 'apparel', 
    title: 'Apparel', 
    image: JACKET_IMAGE,
    path: '/what/product/apparel'
  },
  { 
    id: 'accessories', 
    title: 'Accessories', 
    image: SUNGLASSES_IMAGE,
    path: '/what/product/accessories'
  },
  { 
    id: 'footwear', 
    title: 'Footwear', 
    image: SHOES_IMAGE,
    path: '/what/product/footwear'
  },
];

const ProductCard = ({ category, onClick }) => {
  return (
    <motion.div
      onClick={onClick}
      className="bg-white border border-[rgba(26,26,26,0.1)] overflow-hidden cursor-pointer group"
      whileHover={{ y: -8 }}
      transition={{ duration: 0.4 }}
      data-testid={`product-card-${category.id}`}
    >
      <div className="relative overflow-hidden aspect-[4/5]">
        <motion.img 
          src={category.image} 
          alt={category.title}
          className="w-full h-full object-cover"
          initial={{ scale: 1, filter: 'grayscale(30%)' }}
          whileHover={{ scale: 1.05, filter: 'grayscale(0%)' }}
          transition={{ duration: 0.6 }}
        />
        <div className="absolute inset-0 bg-[#1A1A1A]/0 group-hover:bg-[#1A1A1A]/10 transition-colors duration-500" />
      </div>
      <div className="p-6 border-t border-[rgba(26,26,26,0.1)]">
        <h3 className="text-sm uppercase tracking-[0.2em] font-semibold text-[#1A1A1A] text-center">
          {category.title}
        </h3>
      </div>
    </motion.div>
  );
};

const ProductPage = () => {
  const navigate = useNavigate();

  return (
    <PageTransition className="min-h-screen bg-[#F8F6F2] py-24 px-6">
      <div className="grain-overlay" />
      <BackButton to="/what" label="Back" />

      <div className="max-w-5xl mx-auto">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          className="text-center mb-16"
        >
          <h2 className="text-xs uppercase tracking-[0.3em] text-[#1A1A1A]/60 mb-4">
            Training Modules
          </h2>
          <h1 className="text-4xl md:text-5xl font-light tracking-tight text-[#1A1A1A]">
            Product
          </h1>
        </motion.div>

        <StaggerContainer className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {categories.map((category) => (
            <StaggerItem key={category.id}>
              <ProductCard 
                category={category} 
                onClick={() => navigate(category.path)}
              />
            </StaggerItem>
          ))}
        </StaggerContainer>
      </div>
    </PageTransition>
  );
};

export default ProductPage;
